<template>
  <div class="title">
    <div v-if="breadcrumbs" class="title_breadcrumbs">
      <Breadcrumbs :currentName="currentName" :type="type" />
    </div>
    <h1><slot /></h1>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/UI/Breadcrumbs'

export default {
  components: { Breadcrumbs },
  props: {
    breadcrumbs: Boolean,
    type: {
      type: String,
      default: null,
    },
    currentName: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="less">
	.title {
		display: flex;
		flex-wrap: wrap;

		&_breadcrumbs {
			flex-basis: 100%;

			@media screen and (max-width: 768px) {
				display: flex;
				justify-content: center;
				margin-bottom: 4px;
			}
		}

		& > h1 {
			flex-basis: 100%;
			font-family: 'Aqum', Arial, sans-serif;
			font-weight: 500;
			font-size: 30px;
			margin: 10px 0;

			@media screen and (max-width: 768px) {
				font-size: 28px;
				text-align: center;
			}
		}
	}
</style>
